<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getBufferHeaders ()"
    :items="buffers"
    :loading="loadingBuffer"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <tr>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="[header.sortable ? 'column sortable': '', pagination.descending ? 'desc' : 'acs', header.value === pagination.sortBy ? 'active' : '']"
          class="subheading font-weight-light krita-dark text--darken-3"
          @click="changeSort(header.value,header.sortable)">
          <v-icon
            v-if="header.sortable"
            small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.Amount | amount }}</td>
      <td class="text-xs-left">{{ props.item.FeeAmount | amount }}</td>
      <td class="text-xs-left">{{ props.item.PenaltyInterestAmount | amount }}</td>
      <td class="text-xs-left">{{ props.item.Date | date }}</td>
      <td class="text-xs-left">{{ props.item.DebtorRegistryId }}</td>
      <td class="text-xs-right">{{ props.item.Created | date }}</td>
      <td class="text-xs-right">{{ props.item.PaymentSource }}</td>
      <td class="text-xs-right">
        <router-link 
          :to="{name: 'Factoring detail', params: {id: props.item.FactoringId}}" 
          target="_self">{{ props.item.FactoringId }}</router-link></td>
    </template>
  </v-data-table>
</template>

<script>
    export default {
        name: "FactoringDetailBufferDatagrid",
      // eslint-disable-next-line vue/require-prop-types
        props: ['loadingBuffer','buffers'],
        data ()
        {
            return {
                pagination:
                        {
                          sortBy: 'id'
                        }
            }
        },
        methods: {
            getBufferHeaders ()
            {
                return [
                {sortable: false, text: this.$t('krita.amount'), value: 'amount', align: 'left'},
                {sortable: false, text: this.$t('krita.factoring.feeamount'), value: 'feeAmount', align: 'left'},
                {sortable: false, text: this.$t('krita.factoring.penaltyinterestamount'), value: 'penaltyInterestAmount', align: 'left'},
                {sortable: false, text: this.$t('krita.factoring.date'), value: 'date', align: 'left'},
                {sortable: false, text: this.$t('krita.factoring.payorregistryid'), value: 'payorRegistryId', align: 'left'},
                {sortable: false, text: this.$t('krita.factoring.created'), value: 'created', align: 'right'},
                {sortable: false, text: this.$t('krita.factoring.source'), value: 'source', align: 'right'},
                {sortable: false, text: this.$t('krita.factoring.id'), value: 'source', align: 'right'}
                ]
            },
            changeSort (column,sortable)
            {
                let self = this;

                if (!sortable)
                {
                    return;
                }
                if (self.pagination.sortBy === column)
                {
                    self.pagination.descending = !self.pagination.descending
                }
                else
                {
                    self.pagination.sortBy = column;
                    self.pagination.descending = false;
                }
                self.$emit('refreshWithSort',self.pagination);
            }
        }
    }
</script>

<style scoped>

</style>
